/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { ViewsBaseNav } from './ui/index.tsx';

const LazyViewsNav = lazyForPaint<typeof ViewsBaseNav>(
	() =>
		import(/* webpackChunkName: "async-jsm-views-nav" */ './ui/index.tsx').then(
			({ ViewsBaseNav }) => ViewsBaseNav,
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncViewsNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-jsm-views-nav" fallback={null}>
		<LazyViewsNav />
	</Placeholder>
);
